// export function getQueryStr(name) {
//     var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
//     var r = window.location.search.substring(1).match(reg); //获取url中"?"符后的字符串并正则匹配
//     if (r != null) {
//         return unescape(r[2]);
//     }
//     return null;
// }

export function getQueryStr (name, search) {
    search = search || window.location.search.substring(1) || window.location.hash.split("?")[1] || '';
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = search.match(reg);
    if (r != null){
        return unescape(r[2])
    }; 
    return null;
}

/**
 * 修改url中参数的值
 * @param {*} paramName 参数字段
 * @param {*} replaceWith 替换值
 */
 export function replaceParamUrl(paramName, replaceWith) {
    const oldUrl = window.location.href.toString();
    const re = eval(`/(${paramName}=)([^&]*)/gi`);
    const newUrl = oldUrl.replace(re, `${paramName}=${replaceWith}`);
    window.location.href = newUrl;
}


// WEBPACK FOOTER //
// ./src/utils/index.js